import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { colors, formatUtcDateTime, s } from "../lib/theme";

const STATUS_LABEL = {
  borrador: "Borrador",
  programada: "Programada",
  en_curso: "En curso",
  finalizada: "Finalizada",
};
const STATUS_COLOR = {
  borrador: colors.textFaint,
  programada: colors.amber,
  en_curso: colors.green,
  finalizada: colors.textFaint,
};

export default function Activities() {
  const [activities, setActivities] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.listActivities().then(setActivities).catch((err) => setError(err.message));
  }, []);

  return (
    <div style={s.page}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
        <div>
          <h1 style={s.h1}>Tus actividades</h1>
          <p style={s.subtitle}>Selecciona una actividad para entrar a la matriz banda/modo.</p>
        </div>
      </div>

      {error && <div style={s.errorBox}>{error}</div>}
      {!activities && !error && <p style={{ color: colors.textDim }}>Cargando…</p>}

      {activities && activities.length === 0 && (
        <div style={s.card}>
          <p style={{ color: colors.textDim, margin: 0 }}>
            Todavía no tienes ninguna actividad asignada. Pide a tu organizador que te añada, o
            créala tú mismo desde el panel de <Link to="/organizador" style={{ color: colors.amber }}>Organizador</Link> si administras algún club.
          </p>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {activities?.map((a) => {
          // Estado efectivo: si ya pasó la fecha de fin, se trata como
          // finalizada aunque el campo status todavía no se haya
          // actualizado (el planificador lo hace cada 15 min, esto es
          // inmediato y no depende de esperar a que pase).
          const effectivelyFinished = a.status === "finalizada" || (a.ends_at && new Date(a.ends_at) < new Date());
          const effectiveStatus = effectivelyFinished ? "finalizada" : a.status;
          return (
          <div key={a.id} style={{ ...s.card, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {a.logo_url && (
                <img src={a.logo_url} alt="" style={{ width: 40, height: 40, borderRadius: 6, objectFit: "cover", border: `1px solid ${colors.lineStrong}` }} />
              )}
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: colors.text }}>{a.name}</div>
                <div style={{ fontSize: 12.5, color: colors.textFaint, marginTop: 4 }}>
                  {a.starts_at ? formatUtcDateTime(a.starts_at) : "Sin fecha"}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <span style={{
                fontSize: 12, fontWeight: 700, border: `1.5px solid ${STATUS_COLOR[effectiveStatus]}`,
                color: STATUS_COLOR[effectiveStatus], borderRadius: 5, padding: "4px 10px",
              }}>
                {STATUS_LABEL[effectiveStatus] || effectiveStatus}
              </span>
              {a.status !== "borrador" ? (
                <Link to={`/actividades/${a.id}/matriz`} style={{ ...s.btnGhost, textDecoration: "none" }}>
                  Abrir →
                </Link>
              ) : (
                <span style={{ ...s.btnGhost, opacity: 0.4 }} title="Todavía en borrador">Abrir →</span>
              )}
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
}
